/* Custom Element for Dynamic Payment Offers */
if (!customElements.get('payment-offers')) {
  customElements.define(
    'payment-offers',
    class PaymentOffers extends HTMLElement {
      constructor() {
        super();
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.updatePrices(event.data.variant);
        });
        
        // Initial configuration if variant data is already loaded/configured
        const initialPrice = parseInt(this.dataset.initialPrice);
        if (initialPrice && !isNaN(initialPrice)) {
          this.renderPrices(initialPrice);
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updatePrices(variant) {
        if (!variant) {
          this.style.display = 'none';
          return;
        }
        this.style.display = 'block';
        this.renderPrices(variant.price);
      }

      renderPrices(priceCents) {
        const prepaidPriceEl = this.querySelector('.prepaid-price');
        const originalPriceEl = this.querySelector('.original-price');
        const codPriceEl = this.querySelector('.cod-price');

        // Prepaid price = Variant price * 0.9 (10% off)
        const prepaidCents = Math.round(priceCents * 0.9);
        // COD price = Variant price + 12000 (120 COD charges in cents)
        const codCents = priceCents + 12000;

        if (prepaidPriceEl) prepaidPriceEl.textContent = this.formatCurrency(prepaidCents);
        if (originalPriceEl) originalPriceEl.textContent = this.formatCurrency(priceCents);
        if (codPriceEl) codPriceEl.textContent = this.formatCurrency(codCents);
      }

      formatCurrency(cents) {
        const amount = Math.round(cents / 100);
        // Returns e.g. ₹6,999
        return '₹' + amount.toLocaleString('en-IN');
      }
    }
  );
}
